<template>
  <datatable :type="'companies'" :subType="'pay_group'"
             :rowData="company_pay_groups" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"
             :paginationSize="50"></datatable>
</template>

<script>
import datatable from 'datatables/datatable';

export default {
  name: "company_pay_groups",
  components: {
    datatable
  },
  data() {
    return {
      company_pay_groups: null,
      loadingMessage: 'Loading Pay Groups...',
      noRowsMessage: 'No Pay Groups Found',
      columns: []
    }
  },
  beforeMount() {
    if (this.crmType === 'payroll') {
     this.columns = [
       {headerName: 'Company', field: 'company_name', minWidth: 350},
       {headerName: 'V3 Client', field: 'v3_client', minWidth: 105,sortable: false},
       {headerName: 'Payment Day', field: 'pay_group_day',sortable: false},
       {headerName: 'Payment Time', field: 'pay_group_time', filter:false},
       {headerName: 'Text Day', field: 'text_day',sortable: false},
       {headerName: 'Text Time', field: 'text_time', filter:false},
       {headerName: 'Created By', valueGetter: this.pay_group_created_by,sortable: false, filter:false},
       {headerName: 'Created At', valueGetter: this.pay_group_created_at,sortable: false, filter:false},
     ]
    }
    else if (this.crmType === 'recruitment') {
      this.columns = [
        {headerName: 'Company', field: 'company_name', minWidth: 350},
        {headerName: 'Payment Day', field: 'pay_group_day',sortable: false},
        {headerName: 'Payment Time', field: 'pay_group_time', filter:false},
        {headerName: 'Text Day', field: 'text_day',sortable: false},
        {headerName: 'Text Time', field: 'text_time', filter:false},
        {headerName: 'Created By', valueGetter: this.pay_group_created_by,sortable: false, filter:false},
        {headerName: 'Created At', valueGetter: this.pay_group_created_at,sortable: false, filter:false},
      ]
    }
  },
  mounted() {
    this.get_company_pay_groups();
  },
  methods: {
    get_company_pay_groups() {
      axios.get(this.crmApiPath + 'company/pay_groups/index')
           .then(pay_groups => this.company_pay_groups = pay_groups.data)
           .catch(error => console.log(error.response))
    },
    pay_group_created_by(params) {
      if (params.data.rel_company_logs !== null && params.data.rel_company_logs.length > 0) {
        return params.data.rel_company_logs[0].log_by.first_name + ' ' + params.data.rel_company_logs[0].log_by.surname
      }
    },
    pay_group_created_at(params) {
      if (params.data.rel_company_logs !== null && params.data.rel_company_logs.length > 0) {
        return this.$options.filters.formatDateTime(params.data.rel_company_logs[0].created_at)
      }
    },
  },
  beforeDestroy() {
    this.company_pay_groups = null;
  }
}
</script>

<style scoped>

</style>
